import Vue from 'vue'
import App from './App.vue'
import draggable from 'vuedraggable'
import VueRouter from 'vue-router'

import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

import Login from './components/Login.vue'
import Register from './components/Register.vue'
import Clients from './components/Clients.vue'
import Rooms from './components/Rooms.vue'
import Help from './components/Help.vue'

Vue.config.productionTip = false
Vue.use(VueRouter)

var router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/rooms',
      name: 'Rooms',
      component: Rooms
    },
    {
      path: '/clients',
      name: 'Clients',
      component: Clients
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
  ]
});

var bus = new Vue({});

Object.defineProperty(Vue.prototype, '$bus', {
  get(){
      return this.$root.bus;
  },
  set(newInstance){
      this.$root.bus = newInstance;
  },
});

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
